(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonialreviewscarousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript.closest('[data-rr]');
  if (!root) return;
  const wrap = root.querySelector('[data-rr-wrap]');
  const track = root.querySelector('[data-rr-track]');
  const hint = root.querySelector('[data-rr-hint]');

  if (!wrap || !track || !hint) return;

  const updateHint = () => {
    const canScroll = wrap.scrollWidth > wrap.clientWidth + 8;
    if (canScroll && wrap.scrollLeft < 8) {
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
  };

  updateHint();
  wrap.addEventListener('scroll', updateHint, { passive: true });
  window.addEventListener('resize', updateHint);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.currentScript.closest('[data-video-row]');
  if (!section) return;

  const vids = section.querySelectorAll('video.video-embed');

  // Intersection observer to auto play/pause; ensure loop/muted/inline
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const v = entry.target;
      v.muted = true;
      v.playsInline = true;
      v.loop = true;

      if (entry.isIntersecting) {
        if (v.readyState < 2) v.load();
        const tryPlay = () => v.play().catch(() => {});
        if (v.readyState >= 2) tryPlay();
        else v.addEventListener('loadeddata', tryPlay, { once: true });
      } else {
        v.pause();
      }
    });
  }, { root: null, threshold: 0.15 });

  vids.forEach(v => io.observe(v));
})();

  } catch(e) { console.error(e); }
})();
})();
